/* eslint-disable import/no-unused-modules */
import { FC } from "react";
import { Flex, Text } from "@chakra-ui/react";
import { HeartHand } from "~/icons";
import { Trans } from "~/utils/i18next";
import { Legalese } from "./Legalese";
import { useShowReferAFriend } from "./useShowReferAFriend";

interface Props {
  page: "membershipSelect" | "membershipPayment" | "planPayment" | "planSelect";
  maxW?: string;
  bgColor?: string;
}

export const ReferAFriendAlert: FC<Props> = ({ page, ...props }) => {
  const show = useShowReferAFriend();

  if (!show) return null;

  const i18nKey = `inviteAFriend.invitee.${page}.alert` as const;
  const showLegalese = page === "membershipPayment" || page === "planPayment";

  return (
    <Flex justify="center" mt={2} w="full">
      <Flex
        align="center"
        bgColor="th.yellowGreen1"
        gap={{ base: 2, md: 1 }}
        justify="center"
        p={2}
        w="full"
        {...props}
      >
        <HeartHand color="black" h={6} w={6} />
        <Text variant="th-body3">
          <Trans i18nKey={i18nKey} />
        </Text>
        {showLegalese && <Legalese />}
      </Flex>
    </Flex>
  );
};
